import { Injectable, NgZone } from '@angular/core';
import { LoggingService } from '../../logging/logic/logging.service';
import { ActionHandler, ActionHandlerType } from '../action-handler';
import { WorkingTimeRemoteActionBuilder } from 'src/app/_model/remote-action/remote-action-builder/working-time-remote-action-builder/working-time-remoteaction-builder';
import { WorkingTimeRemoteActionType } from 'src/app/_model/remote-action/remote-action-builder/working-time-remote-action-builder/working-time-remote-action-type';
import { AppService } from '../../app-service/logic/app.service';
import { CredentialsService } from '../../credentials/logic/credentials.service';
import { NavController } from '@ionic/angular';
import { ClientStateService } from '../../client-state/logic/client-state.service';
import { RemoteActionBuilderService } from '../../remote-action-builder/remote-action-builder.service';
import { ServicejobsService } from '../../servicejobs/logic/servicejobs.service';
import { LocationService } from '../../location/location.service';
import { EmployeeService } from '../../employee/logic/employee.service';
import { AppParameterService } from '../../app-parameter/logic/app-parameter.service';
import { JobSectionsService } from '../../job-section/logic/job-section.service';

@Injectable({
  providedIn: 'root',
})
export class EndOfWaitActionHandler implements ActionHandler {
  // Public Member
  public readonly name: ActionHandlerType = 'eowait';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private appService: AppService,
    private credentialsService: CredentialsService,
    private navigationController: NavController,
    private clientStateService: ClientStateService,
    private remoteActionBuilderService: RemoteActionBuilderService,
    private servicejobService: ServicejobsService,
    private locationService: LocationService,
    private employeeService: EmployeeService,
    private jobSectionsService: JobSectionsService,
    private appParameterService: AppParameterService,
    private zone: NgZone
  ) {}

  // ActionHandler
  public async executeAction(params?: any): Promise<any> {
    this.remoteActionBuilderService.newBuild(
      new WorkingTimeRemoteActionBuilder(
        WorkingTimeRemoteActionType.END_OF_WAIT,
        this.clientStateService,
        this.appService,
        this.credentialsService,
        this.servicejobService,
        this.locationService,
        this.employeeService,
        this.jobSectionsService,
        this.appParameterService,
        this.logger
      )
    );
    this.zone.run(() => {
      this.navigationController.navigateForward('/feature/remote-action');
    });
  }

  // Private Functions
}
